function handleCenterSlideVideo(sliderSelector, useCenter = true) {
  function updateSlides() {
    $(sliderSelector + ' .slick-slide').each(function (index, slide) {
      const $slide = $(slide);
      const $video = $slide.find('video').get(0);
      
      if ($video) {
        const shouldPlay = useCenter
          ? ($slide.hasClass('slick-active') || $slide.hasClass('slick-center'))
          : $slide.hasClass('slick-current');
        if (shouldPlay) {
          $video.play().catch((e) => {
            console.warn('Autoplay failed:', e);
          });
        } else {
          $video.pause();
          $video.currentTime = 0;
        }
      }
    });
  }
 
  $(sliderSelector).on('beforeChange', function (event, slick, currentSlide) {
    const videoElement = $(slick.$slides.get(currentSlide)).find('video').get(0);
    if (videoElement) {
      videoElement.pause();
    }
  });
 
 
  $(sliderSelector).on('afterChange', function () {
    updateSlides();
  });
 
  updateSlides();
}
 
$(document).ready(function () {
  const $mainSlider = $('.custom-banner-slider .gallery-slider');
  const totalSlides = $mainSlider.children().length;
 
  // Clone if exactly 5
  if (totalSlides === 5) {
    // $mainSlider.children().clone().addClass('slick-clone-fake').appendTo($mainSlider);
    // addRemoveDuplicateSlides($mainSlider);
  }
 
  $mainSlider.on('init', function () {
    handleCenterSlideVideo('.custom-banner-slider .gallery-slider', true);
  });
 
  $mainSlider.slick({
    infinite: false,
    variableWidth: true, // Fixed width for desktop
    centerMode: true,
    centerPadding: '60px',
    slidesToScroll: 1,
    autoplay: false,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    adaptiveHeight: true,
    swipeToSlide: true,
    asNavFor: '.slider-right .banner-slider-thumb',
    responsive: [
      {
        breakpoint: 750,
        settings: {
          infinite: false,
          variableWidth: true,
          arrows: false,
          centerMode: true,
          slidesToShow: 1,
          centerPadding: '0px',
        }
      }
    ]
  });
 
  $mainSlider.slick('setPosition');

  $('.card-slider-arrows .card-slider-prev').on('click', function() {
    $mainSlider.slick('slickPrev');
  });
  
  $('.card-slider-arrows .card-slider-next').on('click', function() {
    $mainSlider.slick('slickNext');
  });

  const $thumbSlider = $('.slider-right .banner-slider-thumb');
 
  $thumbSlider.on('init', function () {
    handleCenterSlideVideo('.slider-right .banner-slider-thumb', true);
  });  

  $thumbSlider.slick({
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    centerPadding: '20px',
    slidesToShow: 4,
    autoplay: false,
    asNavFor: '.custom-banner-slider .gallery-slider',
    focusOnSelect: true
  });
});

// Function to Add / Remove duplicate slides to slider
function addRemoveDuplicateSlides($mainSlider){
  if($(window).width() > 749){
    $mainSlider.children().clone().addClass('slick-clone-fake').appendTo($mainSlider);
  } else {
    $mainSlider.find('.slick-clone-fake').remove();
  }
}